import React, { useState } from "react";

const ContactForm = () => {
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactMsg, setContactMsg] = useState("");

  const firstNameOnChange = (e) => {
    const data = e.target.value;
    setContactFirstName(data);
  };
  const lastNameOnChange = (e) => {
    const data = e.target.value;
    setContactLastName(data);
  };
  const phoneOnChange = (e) => {
    const data = e.target.value;
    setContactPhone(data);
  };
  const msgOnChange = (e) => {
    const data = e.target.value;
    setContactMsg(data);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // Do the rest later
  };

  return (
    <div>
      <form>
        <div className="input-controller_contact">
          <input
            type="text"
            placeholder="First Name"
            value={contactFirstName}
            onChange={firstNameOnChange}
          />
        </div>
        <div className="input-controller_contact">
          <input
            type="text"
            placeholder="Last Name"
            value={contactLastName}
            onChange={lastNameOnChange}
          />
        </div>
        <div className="input-controller_contact">
          <input
            type="text"
            placeholder="Phone"
            value={contactPhone}
            onChange={phoneOnChange}
          />
        </div>
        <div className="input-controller_contact--message">
          <textarea
            name="message"
            id=""
            cols="30"
            rows="10"
            value={contactMsg}
            placeholder="Message"
            onChange={msgOnChange}
            className="text-box"
          ></textarea>
        </div>
        <button onClick={onSubmit} className="contact_subtmit-btn">
          Send Message
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
